
import React from 'react'

const ErrorFallback = ({error}) => {
    console.log(error)
  return (
    <div><div  className="bg-white text-slate-800">  Something went wrong. Error code : {error.message} </div></div>
  )
}

export default ErrorFallback